import gql from 'graphql-tag';

export const QUERY_ORDERS = gql`
  query queryLandlordOrders($sortBy: OrderSortBy = UPDATED_AT) {
    viewer {
      ... on LandlordContact {
        company {
          pendingConfirmation: orders(
            stages: [WAITING_FOR_CONFIRMATION]
            pageNumber: 1
            pageSize: 10
            sortBy: $sortBy
            bookingJourneys: [SEMI_AUTOMATIC]
          ) {
            pageInfo {
              hasNextPage
            }
            totalCount
            edges {
              node {
                billingCycle
                currency
                id
                moveInDate
                moveOutDate
                propertyId
                propertyName
                referenceId
                stage
                student {
                  firstName
                  id
                  lastName
                  passportFirstName
                  passportLastName
                  passportMiddleName
                }
                totalPrice
                unitTypeCategory
                unitTypeId
                listingId
                listingSalesPrice
                listingDiscountValue
                unitTypeName
                secondaryStage
                instalmentPlanType
                counterOffers {
                  id
                  moveInDate
                  moveOutDate
                  unitTypeName
                  unitTypeCategory
                  totalPrice
                  currency
                  property {
                    name
                  }
                }
                property {
                  id
                  name
                  city {
                    slug
                  }
                }
              }
            }
          }
          pendingRefundOrder: orders(
            stages: [REFUNDING]
            bookingJourneys: [SEMI_AUTOMATIC]
            sortBy: $sortBy
            pageNumber: 1
            pageSize: 10
          ) {
            totalCount
            edges {
              node {
                billingCycle
                currency
                id
                moveInDate
                moveOutDate
                propertyId
                propertyName
                referenceId
                stage
                student {
                  firstName
                  id
                  lastName
                  passportFirstName
                  passportLastName
                  passportMiddleName
                }
                totalPrice
                unitTypeCategory
                unitTypeId
                listingId
                listingSalesPrice
                listingDiscountValue
                unitTypeName
                secondaryStage
                instalmentPlanType
                counterOffers {
                  id
                  moveInDate
                  moveOutDate
                  unitTypeName
                  unitTypeCategory
                  totalPrice
                  currency
                  property {
                    name
                  }
                }
                property {
                  id
                  name
                  city {
                    slug
                  }
                }
              }
            }
          }
          pendingCheckInOrder: orders(
            stages: [WAITING_FOR_CHECK_IN]
            bookingJourneys: [SEMI_AUTOMATIC]
            sortBy: MOVE_IN_DATE
            pageNumber: 1
            pageSize: 10
          ) {
            totalCount
            edges {
              node {
                billingCycle
                currency
                id
                moveInDate
                moveOutDate
                propertyId
                propertyName
                referenceId
                stage
                student {
                  firstName
                  id
                  lastName
                  passportFirstName
                  passportLastName
                  passportMiddleName
                }
                totalPrice
                unitTypeCategory
                unitTypeId
                listingId
                listingSalesPrice
                listingDiscountValue
                unitTypeName
                secondaryStage
                instalmentPlanType
                counterOffers {
                  id
                  moveInDate
                  moveOutDate
                  unitTypeName
                  unitTypeCategory
                  totalPrice
                  currency
                  property {
                    name
                  }
                }
                property {
                  id
                  name
                  city {
                    slug
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const QUERY_DIFFERENT_STAGE_ORDERS = gql`
  query queryLandlordOrderss(
    $sortBy: OrderSortBy = UPDATED_AT
    $pageNumber: PositiveInteger = 2
    $pageSize: PositiveInteger = 10
    $stages: [OrderStage]
  ) {
    viewer {
      ... on LandlordContact {
        company {
          orders(
            stages: $stages
            pageNumber: $pageNumber
            pageSize: $pageSize
            sortBy: $sortBy
            bookingJourneys: [SEMI_AUTOMATIC]
          ) {
            totalCount
            pageInfo {
              hasNextPage
              numPages
            }

            edges {
              node {
                billingCycle
                currency
                id
                moveInDate
                moveOutDate
                propertyId
                propertyName
                referenceId
                stage
                student {
                  firstName
                  id
                  lastName
                  passportFirstName
                  passportLastName
                  passportMiddleName
                }
                totalPrice
                unitTypeCategory
                unitTypeId
                listingId
                listingSalesPrice
                listingDiscountValue
                unitTypeName
                secondaryStage
                instalmentPlanType
                counterOffers {
                  id
                  moveInDate
                  moveOutDate
                  unitTypeName
                  unitTypeCategory
                  totalPrice
                  currency
                  property {
                    name
                  }
                }
                property {
                  id
                  name
                  city {
                    slug
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
